<template>
  <div style="text-align: center;">
    Vous êtes maintenant déconnecté
    <br>
    Vous allez être redirigé sur la page de connexion dans quelque secondes
  </div>
</template>
<script>
import store from '../../store'

export default {
  name: 'Logout',

  mounted () {
    store.dispatch('LogOut').then(() => {
      this.setProtectedTimeout(() => { this.goTo('home') }, 2000)
    })
  },
  methods: {

  },
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Logout.vue?3d773216